import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, WhyUs, NewsletterSection, Features, SpeakerSlider, Sponsors, Tickets, PortfolioSection, Registration, ScheduleTab } from '../../sections';
import { Banner } from '../../components';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Hero section with a call-to-action */}
      <Features /> {/* Features Section */}
      <About /> {/* About the company */}
      <Counter /> {/* Company stats and achievements */}
      <Services /> {/* Services offered */}
      <WhyUs /> {/* Why Attend section */}
      <ScheduleTab /> {/* Event schedule tab */}
      <Banner /> {/* Promotional banner */}
      <SpeakerSlider /> {/* Speaker slider section */}
      <Testimonials /> {/* Client reviews */}
      <Tickets /> {/* Ticket pricing section */}
      <Registration /> {/* Registration form */}
      <PortfolioSection /> {/* Portfolio showcase */}
      <NewsletterSection /> {/* Newsletter subscription form */}
      <Blogs /> {/* Latest blog posts */}
      <Sponsors /> {/* Sponsors Section */}
    </div>
  )

}

export default HomePage;